import React from 'react';
import { Select, MenuItem, FormControl } from '@material-ui/core';

const BooleanFilter = ({ onChange, value }) => {
    const handleChange = event => {
        onChange(event.target.value);
    };

    return (
        <FormControl>
            <Select value={value} onChange={handleChange}>
                <MenuItem key={0} value={false}>
                    <>False</>
                </MenuItem>
                <MenuItem key={1} value={true}>
                    <>True</>
                </MenuItem>
            </Select>
        </FormControl>
    );
};

export { BooleanFilter };
